export default __webpack_public_path__ + "static/media/a-icon-phone.5139e0e6.svg";